var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGentianToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1167_3600)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 26,
    r: 26,
    fill: "#003D7A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 26,
    r: 24.5,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9405 27.5399C41.1589 27.169 42.408 25.2954 42.986 24.3287C43.185 23.9946 43.1046 23.5653 42.7984 23.3252C41.9117 22.6291 40.0693 21.327 38.7986 21.416C37.0685 21.5379 34.4173 22.6227 32.3555 25.7755C35.4163 27.9807 38.2831 28.0442 39.9405 27.5399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5136 23.045C19.5631 22.2015 19.2135 19.9798 19.0961 18.8607C19.0553 18.4745 19.3079 18.1176 19.6881 18.0261C20.7866 17.7619 23.0066 17.3453 24.123 17.9563C25.6438 18.787 27.5972 20.8753 28.1471 24.5972C24.4394 25.3276 21.8086 24.1933 20.5136 23.045Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2474 28.6531C19.2854 29.4852 18.9103 31.7031 18.7789 32.8209C18.733 33.2071 18.9817 33.5666 19.3607 33.6618C20.4554 33.9387 22.6703 34.3821 23.7943 33.785C25.3241 32.9733 27.3042 30.9079 27.8975 27.1923C24.2 26.4175 21.5564 27.5201 20.2474 28.6531Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0384 33.1797C37.4301 34.3877 36.5995 36.4786 36.1326 37.5037C35.9705 37.8581 35.5712 38.0372 35.1986 37.9242C34.118 37.5977 31.9911 36.8381 31.3392 35.7482C30.4512 34.2658 29.8285 31.4801 31.2473 27.9932C34.8146 29.2317 36.5064 31.536 37.0384 33.1797Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4202 17.4235C35.5962 16.1672 34.4173 14.2491 33.7794 13.3205C33.5587 12.9991 33.1351 12.8912 32.7868 13.0665C31.7776 13.5733 29.8153 14.6861 29.3611 15.8725C28.7423 17.4857 28.6109 20.3362 30.6127 23.5272C33.9134 21.6942 35.1803 19.1333 35.4202 17.4235Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1167_3600",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1167_3600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1167_3600",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGentianToken);
export default __webpack_public_path__ + "static/media/Gentian_Token.3abc6a4945940490cacc4c6b4476b63b.svg";
export { ForwardRef as ReactComponent };